import React, { Component } from 'react';
import NavBarItems from '../navbar/navBarItems';
import M from 'materialize-css';
import configs from '../../../configs.json'

class Header extends Component {
    componentDidMount(){
        M.Sidenav.init(this.sidenav)
    }
    render() {
        return (
            <header>
                <div className='navbar-fixed' id='header'>
                    {configs.header.visitor.map((i, index) =>
                        <ul key={'dropdown-' + index} id={"dropdown-" + index} className="dropdown-content">
                        {i.childs.map(c =>
                            <li key={c.name}><a href={c.link}>{c.name}</a></li>
                        )}
                        </ul>
                    )}
                    <nav role="navigation" style={{backgroundColor: configs.colors.primary}}>
                            <a href="/" className="brand-logo center">
                                <img className="responsive-img" alt='website logo' style={{width: '75px', paddingTop: '5px'}} src={require("../../../static/imgs/logo.svg")}/>
                            </a>
                            <a href={configs.links.terms} data-target="slide-out" className="sidenav-trigger">
                                <i className="material-icons">menu</i>
                            </a>
                            <ul className="left hide-on-med-and-down">
                                <NavBarItems color='white'/>
                            </ul>
                    </nav>
                </div>
                <ul className="sidenav" style={{backgroundColor: configs.colors.primary}} ref={ (sidenav) => {this.sidenav = sidenav} } id="slide-out">
                    <li><a href="/"><h4 className='white-text'>{configs.name}</h4></a></li>
                    <li><div className="divider"></div></li>
                    <NavBarItems color='white'/>
                </ul>
            </header >
        );
    }
}

export default Header;